import {
	Box,
	Grid,
	HStack,
	Text
} from '@chakra-ui/react';

import { CommentsItemizedContent } from './comments-itemized-content';

import { useDesign } from '@hooks';

export const CommentPanel = () => {
	const [controller] = useDesign();

	const kitchenData = controller?.kitchen ?? null;


	const headerHeight = '35px';

	return kitchenData
		? (<>
			<Box width="100%" height="100%" overflowY="hidden">
				<Grid width="100%" height="100%" templateRows="auto 1fr 100px">
					<HStack h={headerHeight} w="full" background="blue.400" px={6} py={2} justifyContent={'center'} mb={2}>
						<Text textAlign={'center'} color={'white'} fontSize={18} position="absolute">DESIGN COMMENTS (BETA)</Text>
					</HStack>
					<CommentsItemizedContent kitchenData={kitchenData}/>
				</Grid>
			</Box>
		</>)
		: (
			<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
				<Text>Select a blueprint to view the comments</Text>
			</Box>
		);
};
